import { NavLink, Outlet } from 'react-router-dom';

import '../settings/settings.css';
import '../settings/settingsForms.css';

export function LogatecSettingsLayout() {
  return (
    <div className="settings-layout">
      <nav className="settings-tabs" aria-label="Nastavitve Logatca">
        <NavLink end to="/logatec/nastavitve">
          Mapa
        </NavLink>
      </nav>
      <Outlet />
    </div>
  );
}
